// extracted by mini-css-extract-plugin
export default {"error":"mxa6mA1c2CPNEHVW8PEf"};